import React from 'react'
import { Box } from '@mui/material'
import { VideoView } from '@whereby.com/browser-sdk/react'
import { TESTIDS } from '../../../../config/testids'
import type { ScreenshareWithStream } from './wherebyCallHelpers'
import { SCREENSHARE_VIDEO_STYLE, screenshareStageSx } from './wherebyCallStyles'

interface WherebyScreenshareStageProps {
  screenshares: ScreenshareWithStream[]
}

/** Every screen shared in the call, shown whole (never cropped like a face) beside or above the people; yours plays silent. */
export const WherebyScreenshareStage: React.FC<WherebyScreenshareStageProps> = ({ screenshares }) => (
  <Box data-testid={TESTIDS.WHEREBY_SCREENSHARE_STAGE} sx={screenshareStageSx}>
    {screenshares.map((screenshare) => (
      <VideoView
        key={screenshare.id}
        stream={screenshare.stream}
        muted={screenshare.isLocal}
        style={SCREENSHARE_VIDEO_STYLE}
      />
    ))}
  </Box>
)
